import './aside.css';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useStoreContext } from '../../hooks/context/StoreContext';
import { ReactComponent as IconeUsuario } from '../../assets/icones/person.svg';
import { ReactComponent as IconeMenu } from '../../assets/icones/menu.svg';
import { ReactComponent as IconeVoltar } from '../../assets/icones/arrowback.svg';
import { ReactComponent as IconeModulo } from '../../assets/icones/pageview.svg';
import { ReactComponent as IconeUsuarioPesquisa } from '../../assets/icones/personsearch.svg';
import { ReactComponent as IconeTelaCheia } from '../../assets/icones/fullscreen.svg';
import { ReactComponent as IconeSairTelaCheia } from '../../assets/icones/fullscreenexit.svg';
import { ReactComponent as IconeCentralAtendimento } from '../../assets/icones/support.svg';
import { ReactComponent as IconePermissoes } from '../../assets/icones/checkcircle.svg';
import { verificarTokenViaAxios } from '../../func/verificarToken';
import CentralAtendimentoModal from '../modais/ModalServiceCenter';

const Aside = ({ listaMenu, larguraDoMenu, visibilidadeDoMenu, isMenuOpen, click }) => {
    const asideRef = useRef(null);

    const pathLocation = useLocation();

    const {
        modal,
        setModal,
        dispositivoMovel
    } = useStoreContext();

    const dadosUsuario = useSelector(state => state.usuario.usuario);

    const [abrirCentralAtendimento, setAbrirCentralAtendimento] = useState(false);
    const [validarTelaCheia, setValidarTelaCheia] = useState(false);

    const handleTelaCheia = () => {
        const pagina = document.documentElement;

        if (!validarTelaCheia) {
            pagina.requestFullscreen();
            setValidarTelaCheia(true);
        } else if (validarTelaCheia) {
            document.exitFullscreen();
            setValidarTelaCheia(false);
        };
    };

    const validarRota =
        pathLocation.pathname === '/modulos' ||
            pathLocation.pathname === '/consultar-clientes' ||
            pathLocation.pathname === '/cadastrar-cliente'
            ? true : false;

    const listaItensMenu = [
        {
            icone: IconeModulo,
            texto: 'Módulos',
            rota: '/modulos',
        },
        {
            icone: IconeUsuarioPesquisa,
            texto: 'Consultar Clientes',
            rota: '/consultar-clientes',
        },
        {
            icone: IconeCentralAtendimento,
            texto: 'Central de Atendimento',
            action: () => setAbrirCentralAtendimento(true),
        }
    ];

    useEffect(() => {
        setModal({
            ...modal,
            openModalInformacao: false,
            openModal: false,
            openModalItem: false,
            openModalCliente: false,
            openModalFecharMovimento: false,
            openModalMovimento: false,
        });
    }, [pathLocation]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const menuAberto = isMenuOpen || visibilidadeDoMenu !== 'none';

            if (menuAberto && asideRef.current && !asideRef.current.contains(event.target)) {
                click();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [click, isMenuOpen, visibilidadeDoMenu]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) {
            return;
        };

        document.addEventListener('click', verificarTokenViaAxios);
    }, []);


    useEffect(() => {
        const verificarTelaCheia = () => {
            const emTelaCheia = !!document.fullscreenElement;

            if (emTelaCheia) {
                setValidarTelaCheia(true);
            } else {
                setValidarTelaCheia(false);
            };
        };

        const validarTelaComClick = () => {
            verificarTelaCheia();
        };

        document.addEventListener('fullscreenchange', verificarTelaCheia);
        document.addEventListener('click', validarTelaComClick);

        return () => {
            document.removeEventListener('fullscreenchange', verificarTelaCheia);
            document.removeEventListener('click', validarTelaComClick);
        };
    }, []);

    const validarListaMenu = listaMenu ? listaMenu : listaItensMenu;
    const menuExpandido = isMenuOpen || visibilidadeDoMenu !== 'none';

    return (
        <aside
            ref={asideRef}
            className={`container-aside ${menuExpandido ? 'aberto' : ''}`}
            style={{ width: larguraDoMenu }}
        >
            <nav className='navbar'>
                <div className='navbar-empresa-menu-hamburguer'>
                    <div className='empresa-menu-hamburguer'>
                        <div className='container-empresa' style={{ display: visibilidadeDoMenu }}>
                            <div className='empresa-icone'>
                                <IconeUsuario
                                    width={'48px'}
                                    height={'48px'}
                                    fill={'#000000'}
                                />
                            </div>
                            <div className='empresa-info'>
                                <p className='empresa-info-descricao'>{dadosUsuario.DESCRICAOFUNCIONARIO}</p>
                                <p className='empresa-info-codigo'>{dadosUsuario.CODIGOFUNCIONARIO}</p>
                            </div>
                        </div>
                        <div className='navbar-item-hamburguer'>
                            <IconeMenu
                                tabIndex={0}
                                width={'26px'}
                                height={'26px'}
                                style={{ cursor: 'pointer' }}
                                onClick={click}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        click()
                                    };
                                }}
                            />
                        </div>
                    </div>
                    {!validarRota &&
                        <Link className='navbar-item' to={'/modulos'}>
                            <IconeVoltar
                                width={'26px'}
                                height={'26px'}
                            />
                            <span
                                className='navbar-item-text'
                                style={{ display: visibilidadeDoMenu }}
                            >
                                Voltar para serviços
                            </span>
                        </Link>
                    }
                    {dispositivoMovel &&
                        (!validarTelaCheia ?
                            (<div className='navbar-item'>
                                <IconeTelaCheia
                                    tabIndex={0}
                                    width={'26px'}
                                    height={'26px'}
                                    onClick={handleTelaCheia}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleTelaCheia();
                                        };
                                    }}
                                />
                                <span
                                    style={{ display: visibilidadeDoMenu }}
                                >
                                    Maximinizar tela
                                </span>
                            </div>)
                            :
                            (<div className='navbar-item'>
                                <IconeSairTelaCheia
                                    tabIndex={0}
                                    width={'26px'}
                                    height={'26px'}
                                    onClick={handleTelaCheia}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleTelaCheia();
                                        };
                                    }}
                                />
                                <span
                                    style={{ display: visibilidadeDoMenu }}
                                >
                                    Minimizar tela
                                </span>
                            </div>)
                        )
                    }

                </div>
                <div className='navbar-lista-de-menus'>
                    {validarListaMenu.map((menu, index) => {
                        const menuAtivo = menu.rota === pathLocation.pathname ? 'navbar-item ativo' : 'navbar-item';

                        return menu.rota ? (
                            <Link to={menu.rota} className={menuAtivo} key={index} title={menu.texto}>
                                <menu.icone width='26px' height='26px' />
                                <span className='navbar-item-text' style={{ display: visibilidadeDoMenu }}>{menu.texto}</span>
                            </Link>
                        ) : (
                            <div
                                key={index}
                                className='navbar-item'
                                onClick={menu.action}
                                style={{ cursor: 'pointer' }}
                                title={menu.texto}
                            >
                                <menu.icone width='26px' height='26px' />
                                <span className='navbar-item-text' style={{ display: visibilidadeDoMenu }}>{menu.texto}</span>
                            </div>
                        );
                    })}
                </div>
            </nav>
            {abrirCentralAtendimento && (
                <CentralAtendimentoModal onClose={() => setAbrirCentralAtendimento(false)} />
            )}
        </aside>
    );
};

export default Aside;
